export default "__VITE_ASSET__fb3d42b5__"